import { AlertEmailVerificationModal, EmailIncorrectModal, EnterOTPModal, SuccessModal, MultipleIncorrectInputModal } from './EmailVerificationChildComponents';

export const EMAIL_VERIFICATION_COMPONENTS = [
  {
    component: EmailIncorrectModal,
  },
  {
    component: AlertEmailVerificationModal,
  },
  {
    component: EnterOTPModal,
  },
  {
    component: SuccessModal,
  },
  {
    component: MultipleIncorrectInputModal,
  },
];
